import {FileType} from '../../types';

export const menuItems = [
	{text: 'One PDF file', value: FileType.Pdf, desc: 'per student or class'},
	{text: 'ZIP', value: FileType.Zip, desc: 'Individual PDF files for each student in the class'},
];